export default {
  EASY: {
    Title: 'Easy',
    Color: 'success',
  },
  MEDIUM: {
    Title: 'Medium',
    Color: 'warning',
  },
  HARD: {
    Title: 'Hard',
    Color: 'error',
  },
};
